var generateStyle = function generateStyle(componentTheme) {
  return {
    entryDetail: {
      padding: componentTheme.entryDetailPadding
    },
    headerRow: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      color: componentTheme.headerRowColor
    },
    buttons: {
      position: 'relative',
      display: 'inline-flex',
      zIndex: componentTheme.buttonsZIndex
    },
    expandButtonContainer: {
      borderLeft: "".concat(componentTheme.expandButtonContainerBorderWidth, " solid ").concat(componentTheme.expandButtonContainerBorderColor)
    },
    deleteAlert: {
      display: 'block'
    },
    deletePreface: {
      marginBottom: componentTheme.deletePrefaceMargin
    },
    addButton: {
      marginBottom: componentTheme.addButtonMargin
    },
    headerText: {
      color: componentTheme.headerTextColor,
      fontSize: componentTheme.headerTextFontSize
    },
    stem: {
      fontSize: componentTheme.stemFontSize,
      lineHeight: componentTheme.stemLineHeight,
      '& p': {
        margin: 0
      }
    },
    footer: {
      padding: componentTheme.footerPadding,
      borderTop: "".concat(componentTheme.footerBorderWidth, " solid ").concat(componentTheme.footerBorderColor),
      fontSize: componentTheme.footerFontSize
    }
  };
};
export default generateStyle;